<lib-page-layout>
  <lib-title-navbar pageHeader [showBackArrow]="false" title="Tworzenie nowej grupki"></lib-title-navbar>

  <div class="or-px-20-px or-pt-20-px or-mt-12-px">
    <div>
      <div class="or-d-flex or-flex-col or-align-items-center or-mb-40-px">
        <or-icon name="check" size="xl" circle class="or-mb-16-px or-bg-gradient or-color-white" />
        <div class="or-head-lg or-text-align-center">Gratulacje! Udało Ci się stworzyć nową grupkę! ⚽️</div>
        <div class="or-note-sm or-color-secondary-2 or-mt-12-px">Co warto teraz zrobić?</div>
      </div>

      <button (click)="share()" class="button-secondary-style or-h-48-px or-w-100-pc or-head-md or-mb-8-px">
        <div class="or-align-items-center or-d-flex or-justify-content-center">
          <or-icon name="copy-link" size="m" class="or-mr-12-px" />
          <span>Zaproś za pomocą linku</span>
        </div>
      </button>
      <div class="or-text-align-center or-note-sm or-color-secondary-2 or-mb-20-px">
        Każda osoba z linkiem będzie miała możliwość dopisania się do Twojej grupki.
      </div>

      <button (click)="invitePlayers()" class="button-secondary-style or-h-48-px or-w-100-pc or-head-md or-mb-8-px">
        <div class="or-align-items-center or-d-flex or-justify-content-center">
          <img src="assets/icons/v2/add-player.svg" class="or-mr-12-px" />
          <span>Zaproś graczy</span>
        </div>
      </button>
      <div class="or-text-align-center or-note-sm or-color-secondary-2 or-mb-20-px">
        Grałeś już z kimś w aplikacji? Zaproś go przez aplikacje!
      </div>
    </div>
  </div>

  <lib-page-actions pageActions>
    <button (click)="goToDetails()" class="button-primary-style or-h-48-px or-w-100-pc or-head-md">
      <div class="or-align-items-center or-d-flex or-justify-content-center">
        <or-icon name="games" size="s" class="or-mr-12-px" />
        <span> Przejdź do widoku grupki </span>
      </div>
    </button>
  </lib-page-actions>
</lib-page-layout>
